module.exports = __webpack_public_path__ + "img/shrine64_ua.654c0a5a.webp";